"use strict";

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("./DataDictionaryError");
/**
 * Common superclass of ValidationResult variants used to define mandatory methods.
 */


var ValidationResultBase = function ValidationResultBase() {
  _classCallCheck(this, ValidationResultBase);
};

exports.ValidationResultBase = ValidationResultBase; // tslint:disable-next-line:max-classes-per-file

var ValidationSuccess =
/*#__PURE__*/
function () {
  function ValidationSuccess(value) {
    _classCallCheck(this, ValidationSuccess);

    this.value = value;
    this.valid = true;
  }

  _createClass(ValidationSuccess, [{
    key: "validate",
    value: function validate(next, level) {
      return next.validate(this.value, level);
    }
  }, {
    key: "map",
    value: function map(fn) {
      return fn();
    }
  }, {
    key: "get",
    value: function get() {
      return this.value;
    }
  }]);

  return ValidationSuccess;
}();

exports.ValidationSuccess = ValidationSuccess;

function paramArray(params) {
  return params.map(function (p) {
    return JSON.stringify(p);
  }).join(', ');
} // tslint:disable-next-line:max-classes-per-file


var ValidationError =
/*#__PURE__*/
function () {
  function ValidationError(messageKey) {
    _classCallCheck(this, ValidationError);

    this.messageKey = messageKey;
    this.valid = false;

    for (var _len = arguments.length, msgArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      msgArgs[_key - 1] = arguments[_key];
    }

    this.messageArgs = msgArgs;
  }

  _createClass(ValidationError, [{
    key: "validate",
    value: function validate(next, level) {
      return this;
    }
  }, {
    key: "map",
    value: function map(fn) {
      return this;
    }
  }, {
    key: "get",
    value: function get() {
      throw new DataDictionaryError_1.DataDictionaryError(this.messageKey + ': ' + paramArray(this.messageArgs));
    }
  }]);

  return ValidationError;
}();

exports.ValidationError = ValidationError;